<template>
    <div>
        <!--        标准景展示-->
        <div v-if="$store.state.recordOrderType===0">
            <div class="order-item-content">
                <div class="order-item-content-child">
                    <span style="color: #818181;">订单编号</span><span style="color: #101010;">：{{$store.state.record.demandId}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">需求名称</span><span style="color: #101010;">：{{$store.state.record.requestName}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">处理级别</span><span style="color: #101010;">：{{$store.state.record.processingMethod}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">投影方式</span><span style="color: #101010;">：{{$store.state.record.projection}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">产品类型</span><span style="color: #101010;">：{{$store.state.record.productType}}</span>
                </div>
                <div class="order-item-content-child">
                    <span>
                        <span style="color: #818181;">是否裁剪</span>
                        <span style="color: #101010;">：{{$store.state.record.isClipping==true?'是':'否'}}</span>
                    </span>
                    <v-btn
                            text v-if="$store.state.record.isClipping==true" color="#1E88E5" height="16" style="font-size: 12px;margin-top: -3px;"
                            @click="clippingShow($store.state.record.clippingRegion)"
                    >裁剪范围</v-btn>
                </div>
            </div>
            <v-toolbar light flat width="700" height="40" style="background-color: #F5F5F5;font-size: 12px;color: #848484;">
                <div style="width: 180px;">创建时间：{{$store.state.record.createTime}}</div>
                <div style="margin-left: 74px;width: 200px;">提交人：{{$store.state.record.supervisorUserName}}</div>
                <div style="margin-left: 2px;width: 100px;">产品数量：{{$store.state.record.productDetails.length}}景</div>
                <div style="margin-left: 55px;width: 50px;color: #4C9DF2;cursor: pointer;" @click="exportTxt">导出景ID</div>
            </v-toolbar>
            <v-card flat style="margin-bottom: 20px;">
                <v-list width="700" style="padding: 0px;">
                    <v-list-item v-for="item in $store.state.record.productDetails" :key="item.productId" style="padding: 0px;">
                        <div class="product-item">
                            <div style="display: flex;flex-direction: column;margin-top: 15px;margin-left: 15px;">
                                <img :src="item.jpg" width="125" height="100" @click="showOriginPic(item.productId)">
                                <v-btn text color="#1E88E5" style="font-size: 12px" @click="mapShow(item.imageGeo)">范围浏览</v-btn>
                            </div>
                            <div style="width: 100%;margin: 8px 15px 0px 60px;">
                                <div style="margin: 10px 0px;">ID: {{item.productId}}</div>
                                <div style="display: flex;justify-content: space-between;color: #4A4A4A;">
                                    <div class="product-item-div">
                                        <div>分辨率: {{item.imageGsd}}米</div>
                                        <div>云量: {{item.cloudPercent}}%</div>
                                        <div>传感器: {{item.sensor}}</div>
                                    </div>
                                    <div class="product-item-div">
                                        <div>拍摄卫星: {{item.satelliteId}}</div>
                                        <div>侧摆: {{item.rollSatelliteAngle}}°</div>
                                        <div>太阳高度角: {{item.solarElevation}}°</div>
                                    </div>
                                    <div class="product-item-div">
                                        <div>采集时间: {{item.imagingTime}}</div>
                                        <div>总面积: {{parseInt(item.productArea)}}k㎡</div>
                                        <div>谱段数: {{bandsDetail(item)}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-list-item>
                </v-list>
            </v-card>
        </div>
        <div v-else-if="$store.state.recordOrderType===2">
            <div class="order-item-content">
                <div class="order-item-content-child">
                    <span style="color: #818181;">订单编号</span><span style="color: #101010;">：{{$store.state.record.demandId}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">需求名称</span><span style="color: #101010;">：{{$store.state.record.requestName}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">订单类型</span><span style="color: #101010;">：其他需求</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">创建时间</span><span style="color: #101010;">：{{$store.state.record.createTime}}</span>
                </div>
            </div>
        </div>
        <!--        点编程和大区域-->
        <div v-else>
            <!--            订单信息-->
            <div class="order-item-content">
                <div class="order-item-content-child">
                    <span style="color: #818181;">订单编号</span><span style="color: #101010;">：{{$store.state.record.demandId}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">需求名称</span><span style="color: #101010;">：{{$store.state.record.requestName}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">成像模式</span><span style="color: #101010;">：{{$store.state.record.imagingMode}}</span>
                </div>
                <div v-show="$store.state.record.panelMode==='point'" class="order-item-content-child">
                    <span style="color: #818181;">成像位置</span><span style="color: #101010;">：{{imagePos}}</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">拍摄时间</span>
                    <span style="color: #101010;">：{{$store.state.record.startTime}}—{{$store.state.record.endTime}}</span>
                </div>
                <div v-show="$store.state.record.panelMode==='point'" class="order-item-content-child">
                    <span v-if="$store.state.record.mustImaging">
                        <span style="color: #818181;">特殊频次</span><span style="color: #101010;">逢过必拍</span>
                    </span>
                    <span v-else>
                        <span style="color: #818181;">特殊频次</span><span style="color: #101010;">：指定次数({{$store.state.record.times}})次</span>
                    </span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">云量要求</span><span style="color: #101010;">：≤{{$store.state.record.maxCloud}}°</span>
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">侧摆要求</span><span style="color: #101010;">：≤{{$store.state.record.maxRoll}}°</span>
            
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">处理级别</span><span style="color: #101010;">：{{$store.state.record.processingMethod}}</span>
            
                </div>
                <div class="order-item-content-child">
                    <span style="color: #818181;">投影方式</span><span style="color: #101010;">：{{$store.state.record.projection}}</span>
                </div>
                <div v-show="$store.state.record.panelMode==='area'" class="order-item-content-child">
                    <span style="color: #818181;">区域面积</span><span style="color: #101010;">：{{$store.state.record.selectArea}}k㎡</span>
                </div>
                <div class="order-item-content-child">
                    <span>
                        <span style="color: #818181;">是否裁剪</span><span style="color: #101010;">：{{$store.state.record.isClipping?'是':'否'}}</span>
                    </span>
                    <v-btn
                            text v-if="$store.state.record.isClipping&&$store.state.record.panelMode==='point'" color="#1E88E5" height="16" style="font-size: 12px;margin-top: -3px;"
                            @click="clippingShow($store.state.record.clippingRegion)"
                    >裁剪范围</v-btn>
                </div>
            </div>
            <!--            默认地图展示点-->
            <v-card flat style="width: 700px;height: 280px;margin: 10px 0px 20px;z-index: 0;">
                <l-map
                        ref="map" style="width: 100%;height: 100%;" :maxBounds="L.latLngBounds([[85,-180], [-85,180]])"
                       :center="latLng" :options="options" :zoom="9"
                >
                    <l-tile-layer :url="$store.state.servicePath.tdtVecUrl" :options="subdomains" />
                    <l-tile-layer :url="$store.state.servicePath.tdtVecBzUrl" :options="subdomains" />
                    <l-geo-json :geojson="$store.state.record.geo" :optionsStyle="targetGeojsonStyle"/>
                    <l-marker :lat-lng="latLng"></l-marker>
                </l-map>
            </v-card>
        </div>
    </div>
</template>
<script>
    import { LGeoJson, LMap, LTileLayer, LMarker } from "vue2-leaflet";
    import 'leaflet/dist/leaflet.css';

    export default {
        name: "DemandDetail",
        components: {
            LMap, LTileLayer, LGeoJson, LMarker
        },
        data(){
            return {
                imagePos: "",
                bifProductId: "",
                latLng: [125.6, 10.1],
                geo: { type: "Point", coordinates: [125.6, 10.1] },
                subdomains: { subdomains: ['0', '1', '2', '3'] },
                targetGeojsonStyle: { color: '#00BCD4', weight: 2, fillOpacity: 0 },
                options: { zoomControl: false, attributionControl: false },
            }
        },
        mounted() {
            if (this.$store.state.record.imagingWkt){
                if (this.$store.state.record.imagingWkt.includes('MULTIPOLYGON') || this.$store.state.record.imagingWkt.includes('MULTIPOLYGON')) {
                    this.imagePos = "区域成像"
                } else if (this.$store.state.record.imagingWkt.includes('POINT')){
                    this.imagePos = this.$store.state.record.imagingWkt;
                }
            }
            this.geo = this.$store.state.record.geo;
            if (this.$store.state.record.geo) {
                if(this.$store.state.record.geo.type!== 'Point'){
                    this.$refs.map.mapObject.fitBounds(L.geoJSON(this.$store.state.record.geo).getBounds())
                }else{
                    this.latLng = [ this.$store.state.record.geo.coordinates[1], this.$store.state.record.geo.coordinates[0] ]
                }
            }
        },
        methods: {
            mapShow(wkt){  // 范围浏览
                this.$store.state.geo = JSON.parse(wkt)
                this.$store.state.bounds = L.geoJSON(this.$store.state.geo).getBounds();
                this.$store.state.mapShowDialog = true
            },
            bandsDetail(item) {
                let tmp =''
                if (item.productType === 2 || item.productType === 3){
                    tmp = '3 (R+G+B)'
                } else if (item.productType === 1) {
                    if (item.satelliteId === 'JL101A') {
                        tmp = '5 (PAN+R+G+B+NIR)'
                    } else {
                        tmp = '6 (PAN+R+G+B+Rededge+NIR)'
                    }
                } else if (item.productType === 4) {
                    tmp = '1 ' + item.productBand
                }
                return tmp
            },
            clippingShow(wkt){
                this.$store.state.showClipMap = true;
                console.log(JSON.parse(wkt))
                this.$store.state.geo = JSON.parse(wkt);
                this.$store.state.bounds = L.geoJSON(this.$store.state.geo).getBounds();
            },
            showOriginPic(id) {
                this.$store.state.bifProductId = id;
                this.$store.state.showOriginImage = true;
            },
            exportTxt(){
                let data = "";
                for(let i = 0; i<this.$store.state.record.productDetails.length; i++) {
                    data = data+this.$store.state.record.productDetails[i].productId + "\r";
                }
                let urlObject = window.URL || window.webkitURL || window;
                let export_blob = new Blob([data]);
                let save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
                save_link.href = urlObject.createObjectURL(export_blob);
                save_link.download = '产品清单.txt';
                save_link.click();
            }
        }
    }
</script>
<style scoped>
    .order-item-content {
        width: 700px;
        padding: 10px 20px 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 12px;
    }
    .order-item-content-child {
        width: 50%;
        margin: 5px 0px;
    }
    .product-item {
        display: flex;
        width: 100%;
        background-color: #FAFAFA;
        font-size: 12px;
    }
    .product-item-div div {
        margin: 0px 0px 10px;
    }
</style>